import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProviderRoutingModule } from './provider.routing';
import { ProviderComponent } from './provider.component';
import { ProviderDashboardComponent } from './provider-dashboard/provider-dashboard.component';
import { ProviderParkComponent } from './provider-park/provider-park.component';
import { ProviderRequestsComponent } from './provider-requests/provider-requests.component';

import { ProviderApplyComponent } from './provider-apply/provider-apply.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { SharedModule } from 'src/app/common/modules/shared/shared.module';
import { ProviderBuyComponent } from './provider-buy/provider-buy.component';
import { ProviderRentComponent } from './provider-rent/provider-rent.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ProviderBuyOfferComponent } from './provider-buy-offer/provider-buy-offer.component';
import { ProviderRentOfferComponent } from './provider-rent-offer/provider-rent-offer.component';
import { ProviderKeepOfferComponent } from './provider-keep-offer/provider-keep-offer.component';
import { ProviderKeepComponent } from './provider-keep/provider-keep.component';
import { ProviderOfferCardSellerComponent } from 'src/app/public/car/elements/provider-offer-card-seller/provider-offer-card-seller.component';
import { CarCardSellerComponent } from 'src/app/public/car/elements/car-card-seller/car-card-seller.component';
import { KeepOffersComponent } from 'src/app/public/keep/elements/keep-offers/keep-offers.component';
import { CarCardBuyerComponent } from 'src/app/public/car/elements/car-card-buyer/car-card-buyer.component';
import { ProviderPostingComponent } from './provider-posting/provider-posting.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDivider, MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    ProviderComponent,

    ProviderPostingComponent,
    ProviderBuyComponent,
    ProviderRentComponent,
    ProviderKeepComponent,
    
    ProviderDashboardComponent,
    ProviderParkComponent,

    ProviderBuyOfferComponent,
    ProviderRentOfferComponent,
    ProviderKeepOfferComponent,

    ProviderRequestsComponent,
    ProviderApplyComponent
  ],
  
  imports: [
    CommonModule,
    ProviderRoutingModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,

    MatDividerModule,
    MatDivider,
    
    MatCardModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatExpansionModule,
    MatListModule,
    MatSidenavModule,

    OverlayModule,

    ProviderOfferCardSellerComponent,
    CarCardSellerComponent,
    KeepOffersComponent,
    CarCardBuyerComponent
  ]
})
export class ProviderModule { }
